var exports = {
  "Y": "anchor__C6ha2i",
};

module.exports = exports;
